import { PropsWithChildren } from 'react'
import { cn } from '../../utils'

interface PopupContainerProps extends PropsWithChildren<unknown> {
  className?: string
  labeledBy?: string
  describedBy?: string
}

export const PopupContainer = ({ children, className, labeledBy, describedBy }: PopupContainerProps) => (
  <div
    className="flex flex-col items-center w-fit h-fit focus:outline-none focus:ring-1 focus:ring-neutrals-black"
    tabIndex={0}
    role="dialog"
    aria-labelledby={labeledBy}
    aria-describedby={describedBy}
  >
    <div className="bg-neutrals-900">
      <div className={cn('w-[174px] h-[270px]', className)}>{children}</div>
    </div>
    <span className="text-neutrals-900">
      <PopupAnchor />
    </span>
  </div>
)

const PopupAnchor = () => {
  return (
    <svg width="16" height="7" viewBox="0 0 16 7" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.14835 6.37345L0.774902 0H15.2247L8.85128 6.37345C8.38103 6.8437 7.6186 6.8437 7.14835 6.37345Z"
        fill="currentColor"
      />
    </svg>
  )
}
